(function () {
  // News: one card per view, scrolls through articles
  if (document.querySelector(".news__swiper")) {
    new Swiper(".news__swiper", {
      slidesPerView: 1,
      spaceBetween: 24,
      loop: false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        prevEl: ".news-prev",
        nextEl: ".news-next",
      },
    });
  }

  // Testimonials: 1 / 2 / 3 cards per view, responsive
  const testimonialsWrapper = document.querySelector(
    ".testimonials__swiper .swiper-wrapper"
  );
  if (testimonialsWrapper) {
    // Duplicate the slides so loop mode has enough slides for the 3-up desktop view
    const originalMarkup = testimonialsWrapper.innerHTML;
    while (testimonialsWrapper.querySelectorAll(".swiper-slide").length < 12) {
      testimonialsWrapper.innerHTML += originalMarkup;
    }

    new Swiper(".testimonials__swiper", {
      slidesPerView: 1.2,
      spaceBetween: 24,
      loop: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        prevEl: ".testimonials-prev",
        nextEl: ".testimonials-next",
      },
      breakpoints: {
        768: { slidesPerView: 2, spaceBetween: 40 },
        1024: { slidesPerView: 3 },
      },
    });
  }
})();
